/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_SummaryInputs */

const id_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ringkasan perubahan build`)
};

const ms_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ringkasan perubahan binaan`)
};

const da_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oversigt over buildændringer`)
};

const de_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenfassung der Buildänderungen`)
};

const en_us2_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build change summary`)
};

const es_es2_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de cambios de la compilación`)
};

const es_mx2_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de cambios de la compilación`)
};

const fil_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buod ng mga pagbabago sa build`)
};

const fr_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résumé des modifications du build`)
};

const it_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riepilogo delle modifiche alla build`)
};

const hu_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buildváltozások összegzése`)
};

const nl_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samenvatting van buildwijzigingen`)
};

const no_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammendrag av build-endringer`)
};

const pl_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podsumowanie zmian buildu`)
};

const pt_br2_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo das alterações do build`)
};

const pt_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo das alterações da compilação`)
};

const ro_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezumatul modificărilor buildului`)
};

const fi_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buildin muutosten yhteenveto`)
};

const sv_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammanfattning av buildändringar`)
};

const vi_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tóm tắt thay đổi build`)
};

const tr_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derleme değişiklikleri özeti`)
};

const cs_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souhrn změn buildu`)
};

const bg_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обобщение на промените в компилацията`)
};

const ru_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сводка изменений сборки`)
};

const uk_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підсумок змін білду`)
};

const ar_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملخص تغييرات البناء`)
};

const hi_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिल्ड बदलाव का सारांश`)
};

const th_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สรุปการเปลี่ยนแปลงบิลด์`)
};

const ja_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビルド変更の概要`)
};

const zh_cn2_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建更改摘要`)
};

const zh_hant1_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`組建變更摘要`)
};

const ko_builds_comparison_summary = /** @type {(inputs: Builds_Comparison_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빌드 변경 요약`)
};

/**
* | output |
* | --- |
* | "Build change summary" |
*
* @param {Builds_Comparison_SummaryInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_summary = /** @type {((inputs?: Builds_Comparison_SummaryInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_SummaryInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_summary(inputs)
	if (locale === "ms") return ms_builds_comparison_summary(inputs)
	if (locale === "da") return da_builds_comparison_summary(inputs)
	if (locale === "de") return de_builds_comparison_summary(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_summary(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_summary(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_summary(inputs)
	if (locale === "fil") return fil_builds_comparison_summary(inputs)
	if (locale === "fr") return fr_builds_comparison_summary(inputs)
	if (locale === "it") return it_builds_comparison_summary(inputs)
	if (locale === "hu") return hu_builds_comparison_summary(inputs)
	if (locale === "nl") return nl_builds_comparison_summary(inputs)
	if (locale === "no") return no_builds_comparison_summary(inputs)
	if (locale === "pl") return pl_builds_comparison_summary(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_summary(inputs)
	if (locale === "pt") return pt_builds_comparison_summary(inputs)
	if (locale === "ro") return ro_builds_comparison_summary(inputs)
	if (locale === "fi") return fi_builds_comparison_summary(inputs)
	if (locale === "sv") return sv_builds_comparison_summary(inputs)
	if (locale === "vi") return vi_builds_comparison_summary(inputs)
	if (locale === "tr") return tr_builds_comparison_summary(inputs)
	if (locale === "cs") return cs_builds_comparison_summary(inputs)
	if (locale === "bg") return bg_builds_comparison_summary(inputs)
	if (locale === "ru") return ru_builds_comparison_summary(inputs)
	if (locale === "uk") return uk_builds_comparison_summary(inputs)
	if (locale === "ar") return ar_builds_comparison_summary(inputs)
	if (locale === "hi") return hi_builds_comparison_summary(inputs)
	if (locale === "th") return th_builds_comparison_summary(inputs)
	if (locale === "ja") return ja_builds_comparison_summary(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_summary(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_summary(inputs)
	return ko_builds_comparison_summary(inputs)
});
export { builds_comparison_summary as "builds.comparison.summary" }